import React from 'react'
import './Gallery.css'
// import {Container, Row, Col} from 'react-bootstrap'
import ImageCard1 from "./ImageCard1"
import ImageCard2 from "./ImageCard2";
import ImageCard3 from "./ImageCard3";
import ImageCard4 from "./ImageCard4";
import ImageCard5 from "./ImageCard5";
import ImageCard6 from "./ImageCard6";

function Gallery() {
  return (
    <div style={{paddingBottom:"2rem"}}>
      {/* Gallery Main */}
      <div className="gallery__container">
        <div className="card__container">
          <ImageCard1
            heading="Quarterly Connect"
            cardImage="./images/Gallery/category1-img1-new.jpg"
          />
        </div>
        <div className="card__container">
          <ImageCard2
            heading="Christmas Carnival"
            cardImage="./images/Gallery/category2-img2-new.jpg"
          />
        </div>
        <div className="card__container">
          <ImageCard3
            heading="Stepathon"
            cardImage="./images/Gallery/category4-img5-new.jpg"
          />
        </div>
        <div className="card__container">
          <ImageCard4
            heading="NewMe"
            cardImage="./images/Gallery/category3-img4-new.jpg"
          />
        </div>
        <div className="card__container">
          <ImageCard5
            heading="Health Byte"
            cardImage="./images/Gallery/category5-img-new.jpg"
          />
        </div>
        <div className="card__container">
          <ImageCard6
            heading="IWD"
            cardImage="./images/Gallery/category6-img-new.jpg"
          />
        </div>
      </div>
    </div>
  );
}

export default Gallery